import styled from '@emotion/styled';
import { colors, Text } from '@innovationdepartment/proxima-ui';
import Slider from '@mui/material/Slider';

import type { AgeRange } from '../useAvatarFilters';

const SliderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .MuiSlider-root {
    color: ${colors.neutral80};
  }
`;

type AgeRangeSliderProps = {
  bounds: AgeRange;
  value: AgeRange;
  onChange: (value: AgeRange) => void;
};

const AgeRangeSlider = ({ bounds, value, onChange }: AgeRangeSliderProps) => (
  <SliderWrapper>
    <Text variant="tag2Semibold" color="neutral70">
      {`Age: ${value[0]}–${value[1]}`}
    </Text>
    <Slider
      value={value}
      min={bounds[0]}
      max={bounds[1]}
      onChange={(_, next) => onChange(next as AgeRange)}
      valueLabelDisplay="auto"
      size="small"
      disabled={bounds[0] === bounds[1]}
      getAriaLabel={() => 'Age'}
    />
  </SliderWrapper>
);

export default AgeRangeSlider;
